module.exports = __webpack_public_path__ + "static/media/17UN-Women2.b71e2809.jpg";